import { render, staticRenderFns } from "./UserGroupPlanForm.vue?vue&type=template&id=4c494d47&lang=pug"
import script from "./UserGroupPlanForm.vue?vue&type=script&lang=js"
export * from "./UserGroupPlanForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupPlanForm.vue?vue&type=style&index=0&id=4c494d47&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports